/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
    WorkspaceMember,
    WorkspaceMemberFromJSON,
    WorkspaceMemberFromJSONTyped,
    WorkspaceMemberToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspaceMembersResponse
 */
export interface WorkspaceMembersResponse {
    /**
     * 
     * @type {Array<WorkspaceMember>}
     * @memberof WorkspaceMembersResponse
     */
    results: Array<WorkspaceMember>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof WorkspaceMembersResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof WorkspaceMembersResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof WorkspaceMembersResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof WorkspaceMembersResponse
     */
    hasPreviousPage?: boolean;
}

export function WorkspaceMembersResponseFromJSON(json: any): WorkspaceMembersResponse {
    return WorkspaceMembersResponseFromJSONTyped(json, false);
}

export function WorkspaceMembersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMembersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(WorkspaceMemberFromJSON)),
        'listResult': json['listResult'],
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function WorkspaceMembersResponseToJSON(value?: WorkspaceMembersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(WorkspaceMemberToJSON)),
        'listResult': value.listResult,
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}


